/**
 * Константы для сущности wishlist-item
 */

/**
 * Валюта по умолчанию для отображения цены
 */
export const DEFAULT_CURRENCY = '$';
